"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Thumbs_1 = tslib_1.__importDefault(require("../../Thumbs/mobile/Thumbs"));

require("swiper/dist/css/swiper.css");

var styles = tslib_1.__importStar(require("./ImageSwiper.style"));

function ImageSwiper(_ref) {
  var title = _ref.title,
      provider = _ref.provider,
      imageUrls = _ref.imageUrls,
      initialSlide = _ref.initialSlide;
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [title && provider ? jsx_runtime_1.jsxs("section", Object.assign({
      css: styles.headerWrapper
    }, {
      children: [jsx_runtime_1.jsx("p", Object.assign({
        css: styles.title
      }, {
        children: title
      }), void 0), jsx_runtime_1.jsx("p", Object.assign({
        css: styles.provider
      }, {
        children: provider
      }), void 0)]
    }), void 0) : jsx_runtime_1.jsx("section", Object.assign({
      css: styles.headerWrapper
    }, {
      children: jsx_runtime_1.jsx("p", Object.assign({
        css: styles.title
      }, {
        children: "\uC5EC\uD589\uC790 \uD6C4\uAE30 \uC0AC\uC9C4"
      }), void 0)
    }), void 0), jsx_runtime_1.jsx(Thumbs_1.default, {
      css: styles.thumbs,
      imageUrls: imageUrls,
      initialSlide: initialSlide
    }, void 0)]
  }, void 0);
}

exports.default = ImageSwiper;